module.exports = __webpack_public_path__ + "img/W-26.492ea427.jpg";